<div class="card completion-card">
    <div class="section-header">
        {{ 'profileCompletion.profileCompletion' | translate }}
    </div>
    <div class="completion-header">
        <div class="ring-wrap">
            <svg width="64" height="64" viewBox="0 0 48 48">
                <circle cx="24" cy="24" r="20" fill="none" stroke="#F3F4F6" stroke-width="4" />

                <circle cx="24" cy="24" r="20" fill="none" stroke="#F98650" stroke-width="4" stroke-linecap="round"
                    [attr.stroke-dasharray]="circumference" [attr.stroke-dashoffset]="offset"
                    style="transform: rotate(-90deg); transform-origin: 50% 50%; transition: stroke-dashoffset 0.6s ease" />

                <text x="24" y="24" text-anchor="middle" dominant-baseline="central" font-family="Rubik"
                    font-weight="700" fill="#131B2E" style="font-size: 11px;">
                    {{ percentage }}%
                </text>
            </svg>
        </div>
        <div class="completion-text">
            <p class="completion-label">{{ 'profileCompletion.almostThere' | translate }}</p>
            <p class="completion-hint">{{ 'profileCompletion.addEducationToReach100' | translate }}</p>
        </div>
    </div>
</div>